// My Giving — strictly per-user private ledger.
// All endpoints require the requester to be the owner OR a SA/LA reader.
// The kc_giving_{userId} storage key is firewalled server-side.

import { kcFetch, API_BASE, authHeaders } from "../../lib/apiClient";

async function _send(method, path, body) {
  const res = await kcFetch(`${API_BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `${method} ${path} failed (${res.status})`);
  }
  return res.json();
}

export const apiListGiving   = (userId)        => _send("GET",    `/giving/${userId}`);
export const apiAddGiving    = (userId, e)     => _send("POST",   `/giving/${userId}`, e);
export const apiUpdateGiving = (userId, id, e) => _send("PUT",    `/giving/${userId}/${id}`, e);
export const apiDeleteGiving = (userId, id)    => _send("DELETE", `/giving/${userId}/${id}`);
